module.exports = __webpack_public_path__ + "img/card-logo.3d48c790.svg";